import { ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER, isDevMode } from '@angular/core';
import { provideRouter, withViewTransitions, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { errorInterceptor } from './core/interceptors/http-status.interceptor';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { networkStatusInterceptor } from './core/interceptors/network-status.interceptor';
import { provideStore } from '@ngrx/store';
import { shippingReducer } from './store/shipping/shipping.reducer';
import { hydrationMetaReducer } from './store/meta-reducers/hydration.reducer';
import { ScrollRestorationService } from './core/service/scroll-restoration.service';
import { provideServiceWorker } from '@angular/service-worker';
import { cacheInterceptor } from './core/interceptors/http-cache.interceptor';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';
import { balanceReducer } from './features/perfil-user/store/balance.reducer';
import { AppState } from './store/app.state';
import { cartReducer } from './store/cart/cart.reducer';
import { locationReducer } from './store/location/location.reducer';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { environment } from '../environments/environment';
import { timerReducer } from './store/timer/timer.reducer';
import { tourPerfilReducer } from './store/tour-perfil/tour-perfil-reducer';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';

export const appConfig: ApplicationConfig = {
  providers: [
    provideLottieOptions({
      player: () => player,
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withViewTransitions(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled'
      })
    ),
    provideStore<AppState>({
      balance: balanceReducer,
      shipping: shippingReducer,
      cart: cartReducer,
      location: locationReducer,
      timer: timerReducer,
      tourPerfil: tourPerfilReducer,
    }, { metaReducers: [hydrationMetaReducer] }),
    provideEffects(),
    provideStoreDevtools(),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([cacheInterceptor, networkStatusInterceptor, tokenInterceptor, errorInterceptor]),
      withFetch()
    ),
    provideClientHydration(withEventReplay(),
      withHttpTransferCacheOptions({
        includePostRequests: true
      }),
    ),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideMessaging(() => getMessaging()),
    provideServiceWorker('firebase-messaging-sw.js', {
  enabled: !isDevMode(),
  registrationStrategy: 'registerWhenStable:30000'
})
  ]
};
